import { render, staticRenderFns } from "./MappingSelectionList.vue?vue&type=template&id=f6f988c0&scoped=true"
import script from "./MappingSelectionList.vue?vue&type=script&lang=js"
export * from "./MappingSelectionList.vue?vue&type=script&lang=js"
import style0 from "./MappingSelectionList.vue?vue&type=style&index=0&id=f6f988c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f988c0",
  null
  
)

export default component.exports